// @flow

import gql from 'graphql-tag';

const banditRecommendationQuery = gql`
  query banditRecommendation(
    $name: String!
    $options: [String!]!
    $count: Int = 1
  ) {
    banditRecommendation(name: $name, options: $options, count: $count) {
      id
      identity
      name
      recommendation
    }
  }
`;

export default banditRecommendationQuery;
